// extracted by mini-css-extract-plugin
export var arrowCircle = "Policies-module--arrowCircle--f3d47";
export var cancellationPendingMsg = "Policies-module--cancellationPendingMsg--f5940";
export var carCrashBox = "Policies-module--carCrashBox--f5dad";
export var carCrashBoxContainer = "Policies-module--carCrashBoxContainer--98687";
export var damageTableBox = "Policies-module--damageTableBox--3eab0";
export var damageTableBoxContent = "Policies-module--damageTableBoxContent--cf014";
export var damageTableBoxHeader = "Policies-module--damageTableBoxHeader--d8a5e";
export var damageTableBoxLabel = "Policies-module--damageTableBoxLabel--c88bf";
export var damageTableBoxRow = "Policies-module--damageTableBoxRow--81086";
export var imagesContainer = "Policies-module--imagesContainer--4413b";
export var infoContainer = "Policies-module--infoContainer--f449f";
export var infoIconSvg = "Policies-module--infoIconSvg--90910";
export var infoIconSvgDanger = "Policies-module--infoIconSvgDanger--e99d2";
export var infoIconSvgWarning = "Policies-module--infoIconSvgWarning--07ce0";
export var iphoneGoogleReviews = "Policies-module--iphoneGoogleReviews--d946e";
export var isDisabled = "Policies-module--isDisabled--d2b28";
export var likeIconSvg = "Policies-module--likeIconSvg--7b033";
export var myProfileActions = "Policies-module--myProfileActions--1cf6e";
export var policiesStuff = "Policies-module--policiesStuff--877c2";
export var policyActions = "Policies-module--policyActions--9a725";
export var policyActionsIcon = "Policies-module--policyActionsIcon--facd7";
export var policyContainer = "Policies-module--policyContainer--a55f9";
export var policyHeader = "Policies-module--policyHeader--6e6e6";
export var policyInfo = "Policies-module--policyInfo--ae14a";
export var policyStatusChip = "Policies-module--policyStatusChip--2b1a6";
export var policySubproduct = "Policies-module--policySubproduct--92d14";
export var policyValidity = "Policies-module--policyValidity--8ddc5";
export var policyValidityContent = "Policies-module--policyValidityContent--b9348";
export var ratingBtn = "Policies-module--ratingBtn--b0799";
export var ratingLayoutContainer = "Policies-module--ratingLayoutContainer--ca27c";
export var ratingSvg = "Policies-module--ratingSvg--11955";
export var ratingTextContainer = "Policies-module--ratingTextContainer--a3ece";
export var ratingTitle = "Policies-module--ratingTitle--2f20e";
export var rightArrow = "Policies-module--rightArrow--0d751";
export var seeDetails = "Policies-module--seeDetails--887dc";
export var seeDetailsArrow = "Policies-module--seeDetailsArrow--74d1e";
export var starIconSvg = "Policies-module--starIconSvg--6da49";
export var vignettesContainer = "Policies-module--vignettesContainer--e8c3c";